import { Clock } from 'lucide-react';

export function AuditorExpiredPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-base px-4">
      <div className="w-full max-w-md text-center">
        <Clock className="mx-auto mb-4 h-12 w-12 text-text-tertiary" />
        <h1 className="mb-2 text-2xl font-bold text-text-primary">Access Expired</h1>
        <p className="text-text-secondary">
          Your auditor access window has ended. If you need extended access,
          please contact the organisation's compliance team to request a new invitation.
        </p>
      </div>
    </div>
  );
}
